import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 rounded-t-3xl mx-4 md:mx-6 mt-8">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl font-semibold text-background-50 mb-3">
              Rimani Aggiornato
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5 max-w-sm">
              Iscriviti per ricevere aggiornamenti sulle ultime liste prodotti e guide di Itaobuy Spreadsheet direttamente nella tua casella email.
            </p>
            <form
              data-readdy-form="newsletter"
              id="newsletter-form"
              action="https://readdy.ai/api/form/d9b33uihsavvukudokog"
              method="POST"
              className="flex flex-col sm:flex-row gap-3 max-w-md"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = (formData.get('website_alt') as string || '').trim();
                if (honeypot) {
                  const msg = document.getElementById('newsletter-msg');
                  if (msg) { msg.textContent = 'Grazie per l\'iscrizione!'; msg.className = 'text-xs text-green-400 mt-2'; }
                  form.reset();
                  return;
                }
                try {
                  const res = await fetch(form.action, { method: 'POST', body: new URLSearchParams(formData as unknown as Record<string, string>).toString(), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                  const text = await res.text();
                  let parsed;
                  try { parsed = JSON.parse(text); } catch { parsed = null; }
                  const msg = document.getElementById('newsletter-msg');
                  if (res.ok && parsed?.code === 'OK') {
                    if (msg) { msg.textContent = 'Grazie per l\'iscrizione!'; msg.className = 'text-xs text-green-400 mt-2'; }
                    form.reset();
                  } else {
                    const serverMsg = parsed?.meta?.message || parsed?.message || 'Errore durante l\'iscrizione';
                    if (msg) { msg.textContent = serverMsg; msg.className = 'text-xs text-red-400 mt-2'; }
                  }
                } catch {
                  const msg = document.getElementById('newsletter-msg');
                  if (msg) { msg.textContent = 'Errore di rete. Riprova.'; msg.className = 'text-xs text-red-400 mt-2'; }
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="La tua email"
                required
                className="flex-1 bg-transparent border-b border-foreground-500 text-background-50 text-sm py-2.5 px-1 outline-none focus:border-accent-400 transition-colors placeholder:text-foreground-500"
              />
              <button
                type="submit"
                className="px-6 py-2.5 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Iscriviti
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honey"
              />
            </form>
            <div id="newsletter-msg"></div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Navigazione</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">Home</Link></li>
              <li><Link to="/articolo/guida-completa-itaobuy-spreadsheet" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">Guida Completa</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">Itaobuy Sheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">Buy It Now</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Categorie</h4>
            <ul className="grid grid-cols-2 gap-3">
              {['Shoes', 'Hoodies / Sweaters', 'T-Shirts', 'Jackets', 'Accessories', 'Bags'].map((cat) => (
                <li key={cat}>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">{cat}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400"><i className="ri-twitter-x-line"></i></a>
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400"><i className="ri-instagram-line"></i></a>
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400"><i className="ri-pinterest-line"></i></a>
          </div>
          <p className="text-xs text-foreground-500">
            &copy; 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">Privacy Policy</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-400">Termini</a>
          </div>
        </div>
      </div>
    </footer>
  );
}